import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

export const imgSrc = (u) => (!u ? "" : u.startsWith("/api") ? `${BACKEND_URL}${u}` : u);

export const euro = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(n || 0);

export const errMsg = (e) => e?.response?.data?.detail || "Si è verificato un errore";
